<script lang="ts">
	import TitleContainer from '../itineraries/TitleContainer.svelte'

	interface Props {
		username?: string | null
		platform?: string | null
		isImmutable?: boolean
		platformIcon?: string | null
		onupdateSocialUsername?: (platform: string, username: string) => void
	}

	let {
		username = null,
		platform = null,
		isImmutable = true,
		platformIcon = null,
		onupdateSocialUsername,
	}: Props = $props()

	function updateSocialUsername(title: string, error: boolean) {
		if (error) return
		onupdateSocialUsername?.(platform, title)
	}

	let platformUrl = $derived(
		platform === 'instagram'
			? `https://www.instagram.com/${username}`
			: platform === 'tiktok'
				? `https://tiktok.com/@${username}`
				: '',
	)
</script>

<div
	class={`flex items-center space-x-1 ${
		username == null || username == '' ? 'opacity-50' : 'opacity-100'
	}`}
>
	<img src={platformIcon} alt="" class="h-4 w-4" />
	{#if isImmutable}
		<a
			href={platformUrl}
			target="_blank"
			rel="noopener noreferrer external"
			class="text-xs lg:text-sm"
		>
			{username == null || username == '' || username == 'not set' || username == 'Add a Name'
				? 'not set'
				: username}</a
		>
		<!-- <ImmutableTitle title={username} class="text-xs lg:text-sm" /> -->
	{:else}
		<TitleContainer
			title={username == null || username == '' || username == 'not set' || username == 'Add a Name'
				? 'not set'
				: username}
			onupdateTitle={updateSocialUsername}
			class="mt-2 lg:mt-2 text-sm"
			titleClassNames="text-xs lg:text-sm"
			errorOnNull={false}
		/>
	{/if}
</div>
